module.exports = __webpack_public_path__ + "a0b6a12d1fe710f0e08e3878ce38d0b1.svg";